import { SubBtn } from 'shared/ui';

export const UpdateLink = ({ onClick }) => {
  return <Item text={'정보 수정을 원하시나요?'} onClick={onClick} />;
};

const Item = ({ text, onClick }) => {
  return <SubBtn text={text} onClick={onClick} />;
};
